// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"455":"0ca3249d","488":"65ecbd4c","977":"d5bbc256"}[chunkId] + ".chunk.js");